import { register } from "@rill/loader";

register(
  {
    name: "tutorialCategories",
    meta: ["tutorial-categories"],
    ttl: "2 seconds",
  },
  async ({ api }, product = "general") => {
    const res = await api("tutorial-categories", {
      method: "GET",
      query: {
        product,
      },
    });

    const data = await res.json();

    return data.categories || [];
  }
);

register(
  {
    name: "tutorialVideos",
    meta: ["tutorial-categories-videos"],
    ttl: "2 seconds",
  },
  async ({ api }, { category = "all", product = "general" }) => {
    const res = await api("tutorial-categories-videos", {
      method: "GET",
      query: {
        category,
        product,
      },
    });

    const data = await res.json();

    return data.videos || [];
  }
);
